var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Styles
import { Typography } from '../../../common/styles/typography';
import { getLinkStylesByVariant } from './getLinkStylesByVariant';
// Utils
import styled from 'styled-components';
export var LinkBase = styled(Typography).attrs(function () { return ({
    as: 'a',
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return getLinkStylesByVariant(theme);
});
var templateObject_1;
//# sourceMappingURL=LinkBase.js.map